<h1 mat-dialog-title>SESSION EXPIRING</h1>
<div mat-dialog-content>
    <p>Your session is about to expire due to no activity.</p>
    <p>You will automatically be logged out in</p>
    <div class="countdown">{{counter$|async}}</div>
</div>
<div mat-dialog-actions fxLayoutAlign="center center">
    <button mat-button (click)="dialogRef.close(false)">CANCEL</button>
    <button mat-raised-button color="primary" (click)="dialogRef.close(true)">LOGOUT NOW</button>
</div>